import { MixpanelEventProps } from 'models/MixpanelEvents';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getPageUrl, replaceNullishValues } from 'utils';

const useGetMixpanelProps = () => {
  const { t } = useTranslation();

  return useCallback(
    (props: Partial<MixpanelEventProps> = {}) => {
      const normalizedProps = replaceNullishValues(
        props,
        t('na'),
      ) as Partial<MixpanelEventProps>;

      return {
        pageUrl: getPageUrl(),
        ...normalizedProps,
      };
    },
    [t],
  );
};

export default useGetMixpanelProps;
